/** @jsxImportSource @emotion/react */
import React, { useEffect } from "react";
import { GlobalStore } from "../../store/global/GlobalStore";
import "./OrderCompleted.css";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { DividerContainer } from "./OrderCompleted";
import { Text } from "../../components/general/Text";
import confettiIcon from "../../img/trade-interface/Confetti.svg";
import { css } from "@emotion/react";
import { calculateUsdTradeSurplus } from "../../utils/orderUtils";
import { OrderStatus } from "../../types/orderStatus";

export interface TradeSurplusProps {}

export const TradeSurplus: React.FC<TradeSurplusProps> = () => {
  const { theme, order, quote } = GlobalStore.useState(s => {
    return {
      theme: s.theme,
      order: s.order,
      quote: s.quote,
    };
  });
  const tradeSurplus = calculateUsdTradeSurplus(order, quote);

  useEffect(() => {
    setTimeout(() => {
      GlobalStore.update(s => {
        s.orderStatus = OrderStatus.COMPLETED;
      });
    }, 4000);
  });

  return (
    <TradeSurplusContainer key={1} variants={variants} initial="enter" animate="center" exit="exit">
      <TopSection />
      <ConfettiContainer>
        <StyledConfetti
          src={confettiIcon}
          key={2}
          variants={rotateAndScaleVariants}
          initial="initial"
          animate="animate"
        />
      </ConfettiContainer>
      <div
        css={css`
          position: absolute;
          top: 40%;
          text-align: center;
          z-index: 101;
          width: 100%;
        `}
      >
        <Text textStyle="Title" size="XXL" color={theme.font.reversed.secondary.default}>
          You Received
        </Text>
        <Text
          textStyle="Title"
          size="XXL"
          color={theme.font.reversed.secondary.default}
          textCss={css`
            font-weight: 600;
          `}
        >
          ${tradeSurplus.format(2)} extra
        </Text>
        <Text textStyle="Title" size="XXL" color={theme.font.reversed.secondary.default}>
          on this trade!
        </Text>
      </div>
      <DividerContainer />
      <BottomSection />
    </TradeSurplusContainer>
  );
};
export const TradeSurplusContainer = styled(motion.div)`
  max-width: 392px;
  width: 100%;
  min-height: 604px;
  border-radius: 36px;
  margin: 32px auto auto;
  position: relative;
  max-height: 604px;
  height: 100%;
`;

const ConfettiContainer = styled(motion.div)`
  position: absolute;
  z-index: 100;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  height: 100%;
`;

const StyledConfetti = styled(motion.img)`
  width: 100%;
  height: 100%;
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 36px 36px 0 0;
  background: ${props => props.theme["Dark mode"]["1700"]};
  position: relative;
  height: 291px;
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 0 0 36px 36px;
  background: ${props => props.theme["Dark mode"]["1700"]};
  position: relative;
  height: 291px;
`;

const rotateAndScaleVariants = {
  initial: {
    opacity: 0,
    scale: 0.5,
    rotate: 0,
  },
  animate: {
    opacity: 1,
    scale: 1.4,
    rotate: "-90deg",
    transition: {
      rotate: { type: "ease", duration: 1 },
      scale: { type: "ease", duration: 1 },
      opacity: { type: "ease", duration: 1 },
      delay: 0.4,
    },
  },
};

const variants = {
  enter: {
    y: 50,
    opacity: 0,
    transition: {
      y: { type: "spring", stiffness: 400, damping: 25 },
    },
  },
  center: {
    y: 0,
    opacity: 1,
    transition: {
      y: { type: "spring", stiffness: 400, damping: 25 },
    },
  },
  exit: {
    opacity: 0,
  },
};
